export default __webpack_public_path__ + "static/media/qr.c5a93fac.png";